const mFeedProductsContentModalDuplicate = {
  mFeedProductsContentModalDuplicate: {
    alerts: {
      createProductoClonar: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El producto fue duplicado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'DUPLICAR',

    messageDelete: {
      element: 'Se duplicará el producto',
      options: 'y todas sus características.'
    },

    title: 'Duplicar Producto'
  }
}

export default mFeedProductsContentModalDuplicate
